<template>
  <VoiceSideBar />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
